<template>
  <div class="pt-2">
    <div v-if="settings.appsettings && settings.appsettings.support && settings.appsettings.support.length >0">
      <h6 class="col-12">{{$t("message.Support")}} </h6>
      <div class="col-12 pb-2 pt-2" v-for="support in settings.appsettings.support" :key="support.number">
        <card>
          <div slot="header"><span style="font-weight: 600;">{{getTitle(support.title)}}</span></div>
          <div class="row">
            <div class="col-7">
              {{support.number}}
            </div>
            <div class="col-5" style="text-align: end;">
              <a :href="'tel:' + support.number">
                <n-button type="primary" class="btn-padding light mr-2" round>
                  <i class="fa fa-phone-alt"></i>
                  {{ $t("message.Call") }}
                </n-button>
              </a>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "support",
  methods: {
    //Capitalize first letter
    getTitle(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>
